import { render } from "./ConfigurationOrderCheckboxes.vue?vue&type=template&id=420eb734"
import script from "./ConfigurationOrderCheckboxes.vue?vue&type=script&lang=js"
export * from "./ConfigurationOrderCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationOrderCheckboxes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "420eb734"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('420eb734', __exports__)) {
    console.log('reload')
    api.reload('420eb734', __exports__)
  }
  
  module.hot.accept("./ConfigurationOrderCheckboxes.vue?vue&type=template&id=420eb734", () => {
    console.log('re-render')
    api.rerender('420eb734', render)
  })

}


export default __exports__